"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSaveInteractionType = void 0;
/**
 * Enum to define the type of interaction to be used when saving a document.
 */
var DocumentSaveInteractionType;
(function (DocumentSaveInteractionType) {
    /**
     * Prompt user to choose whether to complete or just save the document.
     */
    DocumentSaveInteractionType["PromptForCompleteOrSave"] = "PromptForCompleteOrSave";
    /**
     * Prompt user to confirm to save and complete the document.
     */
    DocumentSaveInteractionType["PromptForComplete"] = "PromptForComplete";
    /**
     * No prompt. Just save the document directly.
     */
    DocumentSaveInteractionType["NoPrompt"] = "NoPrompt";
})(DocumentSaveInteractionType = exports.DocumentSaveInteractionType || (exports.DocumentSaveInteractionType = {}));
exports.default = DocumentSaveInteractionType;
